import { Form, Input, Row, Col, Button } from "antd";

function PodcastSearch(props: any) {
  const [form] = Form.useForm();

  const onFinish = async (values: any) => {
    let query = "";
    if (values.name) {
      query += `&name=${values.name}`;
    }

    if (values.name) {
      props.handleSearch(query);
    } else {
      props.handleSearch("");
    }
  };

  const resetForm = () => {
    form.resetFields();
  };
  return (
    <Form form={form} onFinish={onFinish}>
      <Row
        gutter={24}
        style={{
          background: "#fff",
          paddingTop: 25,
          margin: 0,
          marginBottom: 20,
          borderRadius: 6,
        }}>
        <Col span={8}>
          <Form.Item name="name" label="Name">
            <Input placeholder="Tìm kiếm tên thể loại..." />
          </Form.Item>
        </Col>
        <Col
          span={16}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            paddingBottom: 25,
          }}>
          <Button
            type="primary"
            onClick={() => {
              form.submit();
            }}
            style={{ marginRight: 12 }}>
            Tìm kiếm
          </Button>
          <Button type="primary" danger onClick={resetForm}>
            Làm lại
          </Button>
        </Col>
      </Row>
    </Form>
  );
}

export default PodcastSearch;
